import React, { Component } from "react"
import { connect } from "react-redux"
import MainActions from "redux-store/models/main"
import AuthActions from "redux-store/models/auth"
import { postImages } from "services/main.js"
import { readFile } from "utils"
import moment from "moment"
import QRCode from "react-qr-code"

class UserDoc extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isPopUpOpen: false,
      loading: false,
      imageUrl: "",
      imageUrl2: "",
    }
  }

  handleChangeFront = (imageUrl) => {
    this.setState({
      imageUrl,
      loading: false,
    })
  }
  handleChangeBack = (imageUrl2) => {
    this.setState({
      imageUrl2,
      loading: false,
    })
  }
  setPopUp = () => {
    this.setState({ isPopUpOpen: !this.state.isPopUpOpen })
  }
  callBack = () => {
    this.props.getUsers(null, null, 25, this.props.page_number)
  }

  render() {
    const { user } = this.props
    const { isPopUpOpen, imageUrl, imageUrl2 } = this.state
    // const uploadButton = (
    //   <div>
    //     <Icon type={this.state.loading ? "loading" : "plus"} />
    //     <div className="ant-upload-text">Upload</div>
    //   </div>
    // );

    const token = JSON.parse(localStorage.getItem("accountDataB")).token

    return (
      <React.Fragment>
        <div className="userList--noDoc__user">
          <div className="body">
            <span>{user.id}</span>
            <span>{user.name}</span>
            <span>{user.codice_fiscale_ordinante}</span>
            <span>{moment(user.created_at, "DD-MM-YYYY").format("DD/MM/YYYY")}</span>
            <span>{user.city}</span>
            <span>{user.comune_code}</span>

            <span
              className=""
              onClick={() => {
                this.setPopUp()
              }}
            >
              <i className="fal fa-plus"></i>
            </span>
            <span
              className=""
              onClick={() => {
                this.props.getUserByUserId(user.user_id)
                this.props.setIsOpen(true)
              }}
              style={{justifyContent: "center"}}
            >
              <i className="fal fa-eye"></i>
            </span>
          </div>
        </div>
        {isPopUpOpen && (
          <div className="popUp">
            <div className="title">{user.document_name}</div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <QRCode
                value={`https://pos.altechsolutions.al/kyc?id=${user.id}&token=${token}`}
                size={200}
                style={{ marginTop: 10 }}
              />
            </div>

            {
              <React.Fragment>
                <span className="uplTitle">Carica Front</span>

                <input
                  id={"inp1"}
                  type="file"
                  onChange={(e) => {
                    readFile(e, this.handleChangeFront)
                  }}
                />
                <label htmlFor="inp1">
                  {imageUrl ? (
                    // eslint-disable-next-line jsx-a11y/alt-text
                    <img src={imageUrl} />
                  ) : (
                    <>
                      {" "}
                      Scegli il file <i className="fal fa-images"></i>
                    </>
                  )}
                </label>
              </React.Fragment>
            }
            {
              <React.Fragment>
                <span className="uplTitle">Carica Back</span>
                <input
                  id={"inp2"}
                  type="file"
                  onChange={(e) => {
                    readFile(e, this.handleChangeBack)
                  }}
                />
                <label htmlFor="inp2">
                  {imageUrl2 ? (
                    // eslint-disable-next-line jsx-a11y/alt-text
                    <img src={imageUrl2} />
                  ) : (
                    <>
                      {" "}
                      Scegli il file <i className="fal fa-images"></i>{" "}
                    </>
                  )}
                </label>
              </React.Fragment>
            }
            <i
              className="fal fa-times"
              onClick={() => {
                this.setPopUp()
              }}
            ></i>
            <button
              className={
                "uploadSendBtn" +
                ((parseInt(user.document_type) === 3 && imageUrl.length > 0) ||
                ((parseInt(user.document_type) === 1 ||
                  parseInt(user.document_type) === 2) &&
                  imageUrl2.length > 0)
                  ? ""
                  : " ")
              }
              onClick={() => {
                postImages(parseInt(user.id), imageUrl, imageUrl2, () => {
                  this.callBack()
                })
                setTimeout(() => {
                  this.setPopUp()
                }, 500)
              }}
            >
              Carica <i className="fas fa-upload"></i>
            </button>
          </div>
        )}
        {isPopUpOpen && (
          <div
            className="backDrop"
            onClick={() => {
              this.setPopUp()
            }}
          ></div>
        )}
      </React.Fragment>
    )
  }
}

const mapsStateToProps = (state) => ({
  accountInfo: state.auth.accountInfo,
})

export default connect(null, { ...MainActions, ...AuthActions })(UserDoc)
